import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';

interface LeaveProgressModalProps {
  isVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const LeaveProgressModal = ({
  isVisible,
  onCancel,
  onConfirm,
}: LeaveProgressModalProps) => {
  return (
    <Modal isVisible={isVisible} close={onCancel} className="w-[624px]">
      <div className="flex w-full flex-col items-start justify-start rounded-[8px] bg-background-base-surface-2 p-8">
        <div className="mb-8 flex flex-col items-start justify-start gap-2">
          <h1 className="text-2xl font-bold text-content-base-default">
            Are you sure you want to leave?
          </h1>
          <p className="text-base font-bold text-content-base-subdued">
            You will lose your current progress if you leave this page.
          </p>
        </div>
        <div className="flex items-start justify-start gap-4">
          <GraniteButton variant="secondary" size="large" onClick={onCancel}>
            Cancel
          </GraniteButton>
          <GraniteButton variant="primary" size="large" onClick={onConfirm}>
            Yes, I&apos;m sure
          </GraniteButton>
        </div>
      </div>
    </Modal>
  );
};

export default LeaveProgressModal;
